import {useEffect} from "react";
import {S3} from "@aws-sdk/client-s3";
import "../assets/css/bookFix.css";
import LeftGnb from "../components/leftGnb";
import AppHeader from "../components/app_header";

const BookFix = () => {
    useEffect(() => {
        const config = {
            credentials: {
                accessKeyId: "AKIAU7XRPY3TKG3GRZ4P",
                secretAccessKey: "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",
            },

            region: "ap-northeast-2",
        };

        var s3 = new S3(config);
        
        function getBookList(bookId) {
            s3.listObjects({Bucket: "segim-edu", Prefix: `media/book/${bookId}/page/`}, function (e, data) {
                console.log(e);
                if (e) {
                    alert("없는 교재입니다. 교재아이디를 다시 확인해주세요.");
                } else {
                    if (document.querySelectorAll(".img_list ul li")[0]) {
                        document.querySelectorAll(".img_list ul li").forEach((item, idx) => {
                            item.remove();
                        });
                    }
                    document.querySelectorAll(".total")[0].textContent = "총 " + data.Contents.length + "페이지가 검색되었습니다.";
                    data.Contents.forEach((item, idx) => {
                        document.querySelectorAll(".img_list ul")[0].insertAdjacentHTML("beforeend", `<li class="new_img_item"><h1>파일명 : ${item.Key.split("/")[item.Key.split("/").length - 1]}</h1><img src="${`https://segim-edu.s3.ap-northeast-2.amazonaws.com/${item.Key}`}"><input type="file" /><div class="appended_button_wrapper"> <button key=${item.Key} class="change_button new_change_button">변경하기</button><button class="change_button">삭제하기</button></div></li>`);

                        document.querySelectorAll(".new_img_item input")[0].addEventListener("change", function () {
                            previewFile(this.parentNode.querySelectorAll("img")[0], this.files[0]);
                        });

                        document.querySelectorAll(".new_change_button")[0].addEventListener("click", function () {
                            if (window.confirm("변경하시겠습니까?")) {
                                const file = this.parentNode.parentNode.querySelectorAll("input")[0].files[0];
                                console.log(this.parentNode.parentNode.querySelectorAll("input")[0]);
                                s3.upload(
                                    {
                                        Bucket: "segim-edu",
                                        Key: item.Key,
                                        Body: file,
                                    },
                                    function (error, data) {
                                        if (error) {
                                            alert("업로드에 실패했습니다.");
                                        } else {
                                            alert("업로드 되었습니다.");
                                        }
                                    }
                                );
                            }
                        });
                        document.querySelectorAll(".new_img_item")[0].classList.remove("new_img_item");
                        document.querySelectorAll(".new_change_button")[0].classList.remove("new_change_button");
                    });
                }
            });
        }
        //파일리더
        function previewFile(preview, file) {
            var reader = new FileReader();
            reader.addEventListener(
                "load",
                function () {
                    preview.src = reader.result;
                },
                false
            );
            if (file) {
                reader.readAsDataURL(file);
            }
        }

        document.querySelectorAll(".get_list")[0].addEventListener("click", function () {
            getBookList(document.querySelector("#book_id").value);
        });
    }, []);

    return (
        <>
            <div className="main_wrapper">
                <LeftGnb />
                <div className="app_wrapper">
                    <AppHeader headerArr={["APP", "교재 PDF부분수정"]} />
                    <div className="wrap">
                        <div className="input_wrapper">
                            <input id="book_id" placeholder="교재아이디값을 입력해주세요." type="text" />
                            <button className="get_list">조회하기</button>
                        </div>
                        <div className="notice_wrapper">
                            <h1 className="notice">파일포멧은 png, 파일가로세로 사이즈는 몰루</h1>
                            <span className="total" />
                        </div>
                        <div className="img_list">
                            <ul />
                        </div>
                        <ul className="update_log">
                            <li>2022-03-11 : 권한설정문제 해결 (업로드시 바로 적용되도록 수정)</li>
                            <li>2022-03-11 : 파일 업로드시 미리보기 지원</li>
                            <li>2022-03-11 : 파일 업로드시 팝업창 노출</li>
                            <li>2022-03-11 : 변경하기 버튼 클릭시 확인 팝업 노출</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};
export default BookFix;
